const editorship = [
  {
    name: 'Yes',
    Percent: 20.3,
    color: '#e87876',
  },
  {
    name: 'No',
    Percent: 79.7,
    color: '#e87876',
  },
];

const age = [
  {
    name: '17',
    Percent: 1.0,
    color: '#fcba64',
  },
  {
    name: '18',
    Percent: 18.3,
    color: '#fcba64',
  },
  {
    name: '19',
    Percent: 28.7,
    color: '#fcba64',
  },
  {
    name: '20',
    Percent: 23.3,
    color: '#fcba64',
  },
  {
    name: '21',
    Percent: 16.3,
    color: '#fcba64',
  },
  {
    name: '22',
    Percent: 6.9,
    color: '#fcba64',
  },
  {
    name: '23',
    Percent: 2.5,
    color: '#fcba64',
  },
  {
    name: 'Other',
    Percent: '0.9',
    color: '#fcba64',
  },
  {
    name: 'PND',
    Percent: 1.5,
    color: '#fcba64',
  },
];

const year = [
  {
    name: 'First Year',
    Percent: 20.7,
    color: '#aacd80',
  },
  {
    name: 'Second Year',
    Percent: 31.5,
    color: '#aacd80',
  },
  {
    name: 'Third Year',
    Percent: 26.1,
    color: '#aacd80',
  },
  {
    name: 'Fourth Year',
    Percent: 18.9,
    color: '#aacd80',
  },
  {
    name: 'Fifth Year+',
    Percent: 1.8,
    color: '#aacd80',
  },
  {
    name: 'Prefer not to disclose',
    Percent: 0.9,
    color: '#aacd80',
  },
];

const transfer = [
  {
    name: 'Yes',
    Percent: 11.3,
    color: '#70aada',
  },
  {
    name: 'No',
    Percent: 88.3,
    color: '#70aada',

  },
  {
    name: 'Prefer not to disclose',
    Percent: 0.5,
    color: '#70aada',

  },
];

const international = [
  {
    name: 'Yes',
    Percent: 6.8,
    color: '#7c7ea7',
  },
  {
    name: 'No',
    Percent: 92.8,
    color: '#7c7ea7',
  },
  {
    name: 'Prefer not to disclose',
    Percent: 0.5,
    color: '#7c7ea7',
  },
];

const gender = [
  {
    name: 'Cisgender man',
    Percent: 27.47,
    color: '#e87876',
  },
  {
    name: 'Cisgender woman',
    Percent: 64.41,
    color: '#e87876',
  },
  {
    name: 'Genderqueer',
    Percent: 1.80,
    color: '#e87876',
  },
  {
    name: 'Nonbinary',
    Percent: 4.5,
    color: '#e87876',
  },
  {
    name: 'Unsure',
    Percent: 2.25,
    color: '#e87876',
  },
  {
    name: 'Other',
    Percent: 1.80,
    color: '#e87876',
  },
];

const lgbtq = [
  {
    name: 'Yes',
    Percent: 35.1,
    color: '#fcba64',
  },
  {
    name: 'No',
    Percent: 57.2,
    color: '#fcba64',
  },
  {
    name: 'Prefer not to disclose',
    Percent: 4.1,
    color: '#fcba64',
  },
  {
    name: 'Unsure',
    Percent: 3.6,
    color: '#fcba64',
  },
];

const sexuality = [
  {
    name: 'Heterosexual',
    Percent: 56.2,
    color: '#aacd80',
  },
  {
    name: 'PND',
    Percent: 4.7,
    color: '#aacd80',
  },
  {
    name: 'Queer',
    Percent: 8.2,
    color: '#aacd80',
  },
  {
    name: 'Bisexual',
    Percent: 15.5,
    color: '#aacd80',
  },
  {
    name: 'Lesbian',
    Percent: 2.6,
    color: '#aacd80',
  },
  {
    name: 'Questioning',
    Percent: 2.6,
    color: '#aacd80',
  },
  {
    name: 'Asexual',
    Percent: 1.3,
    color: '#aacd80',
  },
  {
    name: 'Gay',
    Percent: 6.4,
    color: '#aacd80',
  },
];

const race = [
  {
    name: 'White',
    Percent: 26.1,
    color: '#70aada',
  },

  {
    name: 'Asian',
    Percent: 53.6,
    color: '#70aada',
  },

  {
    name: 'Latine/Hispanic',
    Percent: 14.9,
    color: '#70aada',
  },
  {
    name: 'Indigenous',
    Percent: 0.9,
    color: '#70aada',
  },
  {
    name: 'North African',
    Percent: 0.5,
    color: '#70aada',
  },
  {
    name: 'Middle Eastern',
    Percent: 1.8,
    color: '#70aada',
  },
  {
    name: 'PND',
    Percent: 1.4,
    color: '#70aada',
  },
  {
    name: 'Black',
    Percent: 0.9,
    color: '#70aada',
  },
];

const disability = [
  {
    name: 'Yes',
    Percent: 14.4,
    color: '#7c7ea7',
  },
  {
    name: 'No',
    Percent: 82,
    color: '#7c7ea7',
  },
  {
    name: 'Prefer not to disclose',
    Percent: 3.6,
    color: '#7c7ea7',
  },
];

const semesters = [
  {
    name: '1',
    Percent: 27.9,
    color: '#e87876',
  },
  {
    name: '2',
    Percent: 16.7,
    color: '#e87876',
  },
  {
    name: '3',
    Percent: 19.4,
    color: '#e87876',
  },
  {
    name: '4',
    Percent: 12.6,
    color: '#e87876',
  },
  {
    name: '5',
    Percent: 9.9,
    color: '#e87876',
  },
  {
    name: '6',
    Percent: 3.6,
    color: '#e87876',
  },
  {
    name: '7',
    Percent: 3.2,
    color: '#e87876',
  },
  {
    name: '8',
    Percent: 4.5,
    color: '#e87876',
  },
  {
    name: '9',
    Percent: 0.5,
    color: '#e87876',
  },
  {
    name: '10',
    Percent: 1.8,
    color: '#e87876',
  },
];

// const department = [
//   {
//     name: 'Arts and Entertainment',
//     Percent: 8.1,
//   },
//   {
//     name: 'Blog',
//     Percent: 5.9,
//   },
//   {
//     name: 'Design',
//     Percent: 13.5,
//   },
//   {
//     name: 'Multimedia',
//     Percent: 7.7,
//   },
//   {
//     name: 'News',
//     Percent: 20.3,
//   },
//   {
//     name: 'Night',
//     Percent: 7.2,
//   },
//   {
//     name: 'Opinion',
//     Percent: 3.6,
//   },
//   {
//     name: 'Sports',
//     Percent: 8.1,
//   },
//   {
//     name: 'Photo',
//     Percent: 8.6,
//   },
//   {
//     name: 'Projects',
//     Percent: 5,
//   },
//   {
//     name: 'Social Media',
//     Percent: 7.2,
//   },
//   {
//     name: 'The Weekender',
//     Percent: 6.8,
//   },
//   {
//     name: 'Business Operations',
//     Percent: 0.9,
//   },
//   {
//     name: 'Marketing',
//     Percent: 1.8,
//   },
//   {
//     name: 'Development',
//     Percent: 1.4,
//   },
//   {
//     name: 'Online / tech',
//     Percent: 0.5,
//   },
//   {
//     name: 'Upper Management / DEI Chair',
//     Percent: 0.5,
//   },
//   {
//     name: 'Special Issues',
//     Percent: 0.5,
//   },
// ];

const accessData = {
  Editor: editorship,
  Age: age,
  Year: year,
  'Transfer rate': transfer,
  'International student rate': international,
  Gender: gender,
  'LGBTQ+ rate': lgbtq,
  Sexuality: sexuality,
  'Race and ethnicity': race,
  'Disability rate': disability,
  Semesters: semesters,
};

export default accessData;
